import styled from "styled-components"
import { BREAKPOINT } from "src/helpers/styles"

export const Footer = styled.div`
  padding: 0 30px;
`
export const Menu = styled.ul`
  padding: 0.5rem;
  padding-bottom: 1rem;
  margin-bottom: 0;
  transition: 0.3s;
  box-shadow: var(--box-sidebar);
  background-color: var(--color-background-sidebar);
  li {
    font-size: var(--font-size);
    > a {
      padding: 10px 15px;
      margin-bottom: 0.5rem;
      display: flex;
      align-items: center;
      color: var(--color-text);
      text-decoration: none;
      border-radius: 0.25rem;
      font-weight: 600;
      flex-wrap: nowrap;
      white-space: nowrap;
      overflow: hidden;
      img {
        width: 20px;
        height: auto;
        display: inline-block;
        margin-right: 10px;
      }
      &:hover {
        background-color: var(--color-primary-light);
        color: var(--color-text-primary);
      }
      &.active {
        background: var(--color-primary-light);
        color: var(--color-text-primary);
        position: relative;
      }
      &::after {
        content: "";
        position: absolute;
        z-index: 1;
        top: 50%;
        transform: translate(0, -50%);
        left: 0;
        bottom: 0;
        width: 2px;
        height: 10px;
        border-radius: 0.25rem;
        background-color: transparent;
      }
      &.active::after {
        background-color: currentColor;
      }
      & svg {
        width: 20px;
        height: 20px;
      }
    }
  }
  li:last-child {
    > a {
      margin-bottom: 0;
    }
  }
  & .count {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.2rem;
    border-radius: 50%;
    height: 22px;
    width: -webkit-max-content;
    width: -moz-max-content;
    width: max-content;
    min-width: 22px;
    font-size: 11px;
    border: 1px solid var(--color-primary);
    color: #fff !important;
    background-color: var(--color-primary);
    margin-left: 0.5rem;
  }
`
export const Nav = styled.nav`
  min-width: 256px;
  max-width: 256px;
  background: #303c54;
  color: #fff;
  transition: all 0.3s;
  &.close {
    min-width: 0px;
    max-width: 0px;
    text-align: center;
    ${Menu} {
      li > a {
        padding-right: 0;
        padding-left: 5px;
        span {
          display: none;
        }
        & .count {
          display: none;
        }
      }
    }
    ${Footer} {
      display: none;
    }
  }
  @media (max-width: ${BREAKPOINT.MD - 1}px) {
    min-width: 0px;
    max-width: 0px;
    text-align: center;
    ${Menu} {
      li > a span {
        display: none;
      }
    }
    ${Footer} {
      display: none;
    }
    &.close {
      margin-left: -80px;
    }
  }
  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #303c54;
  }

  &::-webkit-scrollbar {
    width: 6px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 6px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #242e40;
  }
`
export const Logo = styled.a`
  display: block;
  color: #fff;
  font-weight: 900;
  padding: 10px 30px;
  transition: 0.3s;
`
export const Sidebar = styled.div`
  position: relative;
  display: flex;
  & .overlay {
    display: none;
    width: 100vw;
    height: 100%;
    min-height: 100vh;
    top: 0;
    position: absolute;
    left: 0;
    z-index: 1000;
    background-color: rgba(0, 0, 0, 0.2);
  }
  @media (max-width: 768px) {
    & .overlay.open {
      display: block;
    }
    & .c-sidebar {
      max-width: 256px;
      min-width: 256px;
      position: fixed;
      left: 0;
      top: 0;
      z-index: 1001;
      min-height: calc(100vh - 73px);
      height: 100%;
      overflow: auto;
    }
    & .c-sidebar.close {
      margin-left: -256px;
    }
    & .c-sidebar > ul > li > a span {
      display: block;
    }
  }
`
export const CloseSidebar = styled.div`
  display: none;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  padding: 0.5rem;
  & > button {
    background-color: #242e40;
    border-color: #242e40;
  }
  @media (max-width: 768px) {
    display: flex;
  }
`
export const LogoApp = styled.div`
  & img {
    width: 100%;
    height: 40px;
    object-fit: contain;
  }
`
export const Action = styled.div`
  border-top: 1px solid var(--color-primary-light);
  padding: 1rem 0.5rem 0.5rem 0.5rem;
  & .btn {
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
    width: 100%;
    background-color: var(--color-primary-less);
    border-color: var(--color-primary-less);
    color: var(--color-primary);
    padding: 0px 15px;
    height: 40px;
    flex-wrap: nowrap;
    white-space: nowrap;
    overflow: hidden;
    & svg {
      width: 20px;
      height: 20px;
    }
  }
`
